export class ManagementArea {

  name: string = ''; // will be a whole number (unique across management areas)

  ID: string = ''; // FA_ID used for input into DFO FOS

  licenseAreaNames: string[] = []; // all license areas the management area is in

  constructor(name: string = '', ID: string = '', licenseAreaNames: string[] = []) {
      this.name = name;
      this.ID = ID;
      this.licenseAreaNames = licenseAreaNames;
  }

  public toString(): string {
      return 'Area ' + this.name; 
  }

  public isValid(): boolean {
    return !!this.name;
  }

  public static transformAnonymous(managementArea: any): ManagementArea {

    if (!managementArea) { // if the parameter is null
      return new ManagementArea(); // return an empty management area
    }

    return new ManagementArea( // otherwise, transform the parameter to a management area object
      managementArea.name ?? '',
      managementArea.ID ?? '',
      managementArea.licenseAreaNames ?? []
    );
  }

}
